'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../foundational-styles/colors');

var _colors2 = _interopRequireDefault(_colors);

var _fontFamilies = require('./fontFamilies');

var _fontFamilies2 = _interopRequireDefault(_fontFamilies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Heading styles.
 * @property {Object} headings.900
 * @property {Object} headings.800
 * @property {Object} headings.700
 * @property {Object} headings.600
 * @property {Object} headings.500 - Default.
 * @property {Object} headings.400
 * @property {Object} headings.300
 * @property {Object} headings.200
 * @property {Object} headings.100
 */
exports.default = {
  '900': {
    fontSize: '35px',
    fontWeight: 500,
    lineHeight: '40px',
    letterSpacing: '-0.2px',
    marginTop: 52,
    fontFamily: _fontFamilies2.default.display,
    color: _colors2.default.text.dark
  },
  '800': {
    fontSize: '29px',
    fontWeight: 500,
    lineHeight: '32px',
    letterSpacing: '-0.2px',
    marginTop: 40,
    fontFamily: _fontFamilies2.default.display,
    color: _colors2.default.text.dark
  },
  '700': {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '28px',
    letterSpacing: '-0.07px',
    marginTop: 40,
    fontFamily: _fontFamilies2.default.display,
    color: _colors2.default.text.dark
  },
  '600': {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '-0.07px',
    marginTop: 28,
    fontFamily: _fontFamilies2.default.display,
    color: _colors2.default.text.dark
  },
  '500': {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.05px',
    marginTop: 24,
    fontFamily: _fontFamilies2.default.ui,
    color: _colors2.default.text.dark
  },
  '400': {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '-0.05px',
    marginTop: 16,
    fontFamily: _fontFamilies2.default.ui,
    color: _colors2.default.text.dark
  },
  '300': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0',
    marginTop: 16,
    fontFamily: _fontFamilies2.default.ui,
    color: _colors2.default.text.dark
  },
  '200': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    marginTop: 16,
    fontFamily: _fontFamilies2.default.ui,
    color: _colors2.default.text.muted
  },
  '100': {
    fontSize: '11px',
    fontWeight: 400,
    textTransform: 'uppercase',
    lineHeight: '16px',
    letterSpacing: '0.6px',
    marginTop: 16,
    fontFamily: _fontFamilies2.default.ui,
    color: _colors2.default.text.muted
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS90eXBvZ3JhcGh5L2hlYWRpbmdzLmpzIl0sIm5hbWVzIjpbImZvbnRTaXplIiwiZm9udFdlaWdodCIsImxpbmVIZWlnaHQiLCJsZXR0ZXJTcGFjaW5nIiwibWFyZ2luVG9wIiwiZm9udEZhbWlseSIsImZvbnRGYW1pbGllcyIsImRpc3BsYXkiLCJjb2xvciIsImNvbG9ycyIsInRleHQiLCJkYXJrIiwidWkiLCJtdXRlZCIsInRleHRUcmFuc2Zvcm0iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7OztBQUVBOzs7Ozs7Ozs7Ozs7a0JBWWU7QUFDYixTQUFPO0FBQ0xBLGNBQVUsTUFETDtBQUVMQyxnQkFBWSxHQUZQO0FBR0xDLGdCQUFZLE1BSFA7QUFJTEMsbUJBQWUsUUFKVjtBQUtMQyxlQUFXLEVBTE47QUFNTEMsZ0JBQVlDLHVCQUFhQyxPQU5wQjtBQU9MQyxXQUFPQyxpQkFBT0MsSUFBUCxDQUFZQztBQVBkLEdBRE07QUFVYixTQUFPO0FBQ0xYLGNBQVUsTUFETDtBQUVMQyxnQkFBWSxHQUZQO0FBR0xDLGdCQUFZLE1BSFA7QUFJTEMsbUJBQWUsUUFKVjtBQUtMQyxlQUFXLEVBTE47QUFNTEMsZ0JBQVlDLHVCQUFhQyxPQU5wQjtBQU9MQyxXQUFPQyxpQkFBT0MsSUFBUCxDQUFZQztBQVBkLEdBVk07QUFtQmIsU0FBTztBQUNMWCxjQUFVLE1BREw7QUFFTEMsZ0JBQVksR0FGUDtBQUdMQyxnQkFBWSxNQUhQO0FBSUxDLG1CQUFlLFNBSlY7QUFLTEMsZUFBVyxFQUxOO0FBTUxDLGdCQUFZQyx1QkFBYUMsT0FOcEI7QUFPTEMsV0FBT0MsaUJBQU9DLElBQVAsQ0FBWUM7QUFQZCxHQW5CTTtBQTRCYixTQUFPO0FBQ0xYLGNBQVUsTUFETDtBQUVMQyxnQkFBWSxHQUZQO0FBR0xDLGdCQUFZLE1BSFA7QUFJTEMsbUJBQWUsU0FKVjtBQUtMQyxlQUFXLEVBTE47QUFNTEMsZ0JBQVlDLHVCQUFhQyxPQU5wQjtBQU9MQyxXQUFPQyxpQkFBT0MsSUFBUCxDQUFZQztBQVBkLEdBNUJNO0FBcUNiLFNBQU87QUFDTFgsY0FBVSxNQURMO0FBRUxDLGdCQUFZLEdBRlA7QUFHTEMsZ0JBQVksTUFIUDtBQUlMQyxtQkFBZSxTQUpWO0FBS0xDLGVBQVcsRUFMTjtBQU1MQyxnQkFBWUMsdUJBQWFNLEVBTnBCO0FBT0xKLFdBQU9DLGlCQUFPQyxJQUFQLENBQVlDO0FBUGQsR0FyQ007QUE4Q2IsU0FBTztBQUNMWCxjQUFVLE1BREw7QUFFTEMsZ0JBQVksR0FGUDtBQUdMQyxnQkFBWSxNQUhQO0FBSUxDLG1CQUFlLFNBSlY7QUFLTEMsZUFBVyxFQUxOO0FBTUxDLGdCQUFZQyx1QkFBYU0sRUFOcEI7QUFPTEosV0FBT0MsaUJBQU9DLElBQVAsQ0FBWUM7QUFQZCxHQTlDTTtBQXVEYixTQUFPO0FBQ0xYLGNBQVUsTUFETDtBQUVMQyxnQkFBWSxHQUZQO0FBR0xDLGdCQUFZLE1BSFA7QUFJTEMsbUJBQWUsR0FKVjtBQUtMQyxlQUFXLEVBTE47QUFNTEMsZ0JBQVlDLHVCQUFhTSxFQU5wQjtBQU9MSixXQUFPQyxpQkFBT0MsSUFBUCxDQUFZQztBQVBkLEdBdkRNO0FBZ0ViLFNBQU87QUFDTFgsY0FBVSxNQURMO0FBRUxDLGdCQUFZLEdBRlA7QUFHTEMsZ0JBQVksTUFIUDtBQUlMRSxlQUFXLEVBSk47QUFLTEMsZ0JBQVlDLHVCQUFhTSxFQUxwQjtBQU1MSixXQUFPQyxpQkFBT0MsSUFBUCxDQUFZRztBQU5kLEdBaEVNO0FBd0ViLFNBQU87QUFDTGIsY0FBVSxNQURMO0FBRUxDLGdCQUFZLEdBRlA7QUFHTGEsbUJBQWUsV0FIVjtBQUlMWixnQkFBWSxNQUpQO0FBS0xDLG1CQUFlLE9BTFY7QUFNTEMsZUFBVyxFQU5OO0FBT0xDLGdCQUFZQyx1QkFBYU0sRUFQcEI7QUFRTEosV0FBT0MsaUJBQU9DLElBQVAsQ0FBWUc7QUFSZDtBQXhFTSxDIiwiZmlsZSI6ImhlYWRpbmdzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGNvbG9ycyBmcm9tICcuLi9mb3VuZGF0aW9uYWwtc3R5bGVzL2NvbG9ycydcbmltcG9ydCBmb250RmFtaWxpZXMgZnJvbSAnLi9mb250RmFtaWxpZXMnXG5cbi8qKlxuICogSGVhZGluZyBzdHlsZXMuXG4gKiBAcHJvcGVydHkge09iamVjdH0gaGVhZGluZ3MuOTAwXG4gKiBAcHJvcGVydHkge09iamVjdH0gaGVhZGluZ3MuODAwXG4gKiBAcHJvcGVydHkge09iamVjdH0gaGVhZGluZ3MuNzAwXG4gKiBAcHJvcGVydHkge09iamVjdH0gaGVhZGluZ3MuNjAwXG4gKiBAcHJvcGVydHkge09iamVjdH0gaGVhZGluZ3MuNTAwIC0gRGVmYXVsdC5cbiAqIEBwcm9wZXJ0eSB7T2JqZWN0fSBoZWFkaW5ncy40MDBcbiAqIEBwcm9wZXJ0eSB7T2JqZWN0fSBoZWFkaW5ncy4zMDBcbiAqIEBwcm9wZXJ0eSB7T2JqZWN0fSBoZWFkaW5ncy4yMDBcbiAqIEBwcm9wZXJ0eSB7T2JqZWN0fSBoZWFkaW5ncy4xMDBcbiAqL1xuZXhwb3J0IGRlZmF1bHQge1xuICAnOTAwJzoge1xuICAgIGZvbnRTaXplOiAnMzVweCcsXG4gICAgZm9udFdlaWdodDogNTAwLFxuICAgIGxpbmVIZWlnaHQ6ICc0MHB4JyxcbiAgICBsZXR0ZXJTcGFjaW5nOiAnLTAuMnB4JyxcbiAgICBtYXJnaW5Ub3A6IDUyLFxuICAgIGZvbnRGYW1pbHk6IGZvbnRGYW1pbGllcy5kaXNwbGF5LFxuICAgIGNvbG9yOiBjb2xvcnMudGV4dC5kYXJrXG4gIH0sXG4gICc4MDAnOiB7XG4gICAgZm9udFNpemU6ICcyOXB4JyxcbiAgICBmb250V2VpZ2h0OiA1MDAsXG4gICAgbGluZUhlaWdodDogJzMycHgnLFxuICAgIGxldHRlclNwYWNpbmc6ICctMC4ycHgnLFxuICAgIG1hcmdpblRvcDogNDAsXG4gICAgZm9udEZhbWlseTogZm9udEZhbWlsaWVzLmRpc3BsYXksXG4gICAgY29sb3I6IGNvbG9ycy50ZXh0LmRhcmtcbiAgfSxcbiAgJzcwMCc6IHtcbiAgICBmb250U2l6ZTogJzI0cHgnLFxuICAgIGZvbnRXZWlnaHQ6IDUwMCxcbiAgICBsaW5lSGVpZ2h0OiAnMjhweCcsXG4gICAgbGV0dGVyU3BhY2luZzogJy0wLjA3cHgnLFxuICAgIG1hcmdpblRvcDogNDAsXG4gICAgZm9udEZhbWlseTogZm9udEZhbWlsaWVzLmRpc3BsYXksXG4gICAgY29sb3I6IGNvbG9ycy50ZXh0LmRhcmtcbiAgfSxcbiAgJzYwMCc6IHtcbiAgICBmb250U2l6ZTogJzIwcHgnLFxuICAgIGZvbnRXZWlnaHQ6IDUwMCxcbiAgICBsaW5lSGVpZ2h0OiAnMjRweCcsXG4gICAgbGV0dGVyU3BhY2luZzogJy0wLjA3cHgnLFxuICAgIG1hcmdpblRvcDogMjgsXG4gICAgZm9udEZhbWlseTogZm9udEZhbWlsaWVzLmRpc3BsYXksXG4gICAgY29sb3I6IGNvbG9ycy50ZXh0LmRhcmtcbiAgfSxcbiAgJzUwMCc6IHtcbiAgICBmb250U2l6ZTogJzE2cHgnLFxuICAgIGZvbnRXZWlnaHQ6IDUwMCxcbiAgICBsaW5lSGVpZ2h0OiAnMjBweCcsXG4gICAgbGV0dGVyU3BhY2luZzogJy0wLjA1cHgnLFxuICAgIG1hcmdpblRvcDogMjQsXG4gICAgZm9udEZhbWlseTogZm9udEZhbWlsaWVzLnVpLFxuICAgIGNvbG9yOiBjb2xvcnMudGV4dC5kYXJrXG4gIH0sXG4gICc0MDAnOiB7XG4gICAgZm9udFNpemU6ICcxNHB4JyxcbiAgICBmb250V2VpZ2h0OiA2MDAsXG4gICAgbGluZUhlaWdodDogJzIwcHgnLFxuICAgIGxldHRlclNwYWNpbmc6ICctMC4wNXB4JyxcbiAgICBtYXJnaW5Ub3A6IDE2LFxuICAgIGZvbnRGYW1pbHk6IGZvbnRGYW1pbGllcy51aSxcbiAgICBjb2xvcjogY29sb3JzLnRleHQuZGFya1xuICB9LFxuICAnMzAwJzoge1xuICAgIGZvbnRTaXplOiAnMTJweCcsXG4gICAgZm9udFdlaWdodDogNjAwLFxuICAgIGxpbmVIZWlnaHQ6ICcxNnB4JyxcbiAgICBsZXR0ZXJTcGFjaW5nOiAnMCcsXG4gICAgbWFyZ2luVG9wOiAxNixcbiAgICBmb250RmFtaWx5OiBmb250RmFtaWxpZXMudWksXG4gICAgY29sb3I6IGNvbG9ycy50ZXh0LmRhcmtcbiAgfSxcbiAgJzIwMCc6IHtcbiAgICBmb250U2l6ZTogJzEycHgnLFxuICAgIGZvbnRXZWlnaHQ6IDYwMCxcbiAgICBsaW5lSGVpZ2h0OiAnMTZweCcsXG4gICAgbWFyZ2luVG9wOiAxNixcbiAgICBmb250RmFtaWx5OiBmb250RmFtaWxpZXMudWksXG4gICAgY29sb3I6IGNvbG9ycy50ZXh0Lm11dGVkXG4gIH0sXG4gICcxMDAnOiB7XG4gICAgZm9udFNpemU6ICcxMXB4JyxcbiAgICBmb250V2VpZ2h0OiA0MDAsXG4gICAgdGV4dFRyYW5zZm9ybTogJ3VwcGVyY2FzZScsXG4gICAgbGluZUhlaWdodDogJzE2cHgnLFxuICAgIGxldHRlclNwYWNpbmc6ICcwLjZweCcsXG4gICAgbWFyZ2luVG9wOiAxNixcbiAgICBmb250RmFtaWx5OiBmb250RmFtaWxpZXMudWksXG4gICAgY29sb3I6IGNvbG9ycy50ZXh0Lm11dGVkXG4gIH1cbn1cbiJdfQ==